/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFinding {
    getFixupPrototypeFunction() { return SecurityFinding.fixupPrototype; }

    static newInstance(model: Partial<SecurityFinding>): SecurityFinding {
        let obj = Object.assign(new SecurityFinding(), model);
        SecurityFinding.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFinding>): SecurityFinding {
        if (!model) return null;
        return SecurityFinding.newInstance(<SecurityFinding> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFinding) {
        if (!obj) return;

        models.SecurityFinding.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFinding): boolean {
        Object.setPrototypeOf(obj, SecurityFinding.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Unique identifier for the security finding record in the system
     */
    finding_id: string;

    /**
     * High-level classification of the security finding type (Misconfiguration, Vulnerability, or Threat)
     */
    category: models.SecurityFindingsCategory;

    /**
     * Name of the security scanning tool that originally detected and reported this finding
     */
    source_tool: models.SecurityFindingsSourceTool;

    /**
     * Phase in the software development lifecycle when this security issue was detected (Build or Runtime)
     */
    execution_phase: models.SecurityFindingsExecutionPhase;

    /**
     * Architectural layer where the security issue exists (Container, Infrastructure, Supplychain, or API)
     */
    layer: models.SecurityFindingsLayer;

    /**
     * Normalized severity level indicating the criticality and potential impact of the security finding
     */
    severity: models.SecurityFindingsSeverity;

    /**
     * Current resolution status of the security finding (open for unresolved, resolved for fixed)
     */
    status: models.SecurityFindingsStatus;

    /**
     * Concise, human-readable summary title describing the specific security issue found
     */
    title: string;

    /**
     * Detailed explanation of the security finding, including what was detected and why it is a concern
     */
    description: string;

    /**
     * Actionable guidance and best practices for addressing and resolving the security finding
     */
    recommendation: string;

    /**
     * Specific step-by-step instructions for fixing the security issue and preventing recurrence
     */
    remediation: string;

    /**
     * Timestamp indicating when this security finding was first discovered and recorded in the system
     */
    created_at: Date;

    /**
     * Timestamp of the most recent modification or status change to this security finding record
     */
    updated_at: Date;

}
